import * as Actions from '../actions/developer.actions';

const initialState = {
    clusters: [],
    loading: false,
    error: null,
    logs: '',
    executionResult: null,
    terminal: {
        connected: false,
        connecting: false,
        session: null,
        output: []
    }
};

const developer = (state = initialState, action) => {
    switch (action.type) {
        case Actions.SET_DEVELOPER_CLUSTERS:
            return {
                ...state,
                clusters: action.payload,
                error: null
            };
        case Actions.SET_DEVELOPER_CLUSTERS_LOADING:
            return {
                ...state,
                loading: action.payload
            };
        case Actions.SET_DEVELOPER_CLUSTERS_ERROR:
            return {
                ...state,
                error: action.payload,
                loading: false
            };
        case Actions.SET_DEVELOPER_CLUSTER_LOGS:
            return {
                ...state,
                logs: action.payload
            };
        case Actions.SET_DEVELOPER_EXECUTION_RESULT:
            return {
                ...state,
                executionResult: action.payload
            };
        case Actions.CLEAR_DEVELOPER_DATA:
            return {
                ...initialState
            };
        case Actions.SET_TERMINAL_CONNECTED:
            return {
                ...state,
                terminal: {
                    ...state.terminal,
                    connected: action.payload
                }
            };
        case Actions.SET_TERMINAL_CONNECTING:
            return {
                ...state,
                terminal: {
                    ...state.terminal,
                    connecting: action.payload
                }
            };
        case Actions.SET_TERMINAL_SESSION:
            return {
                ...state,
                terminal: {
                    ...state.terminal,
                    session: action.payload
                }
            };
        case Actions.SET_TERMINAL_OUTPUT:
            return {
                ...state,
                terminal: {
                    ...state.terminal,
                    output: action.payload
                }
            };
        case Actions.ADD_TERMINAL_OUTPUT:
            return {
                ...state,
                terminal: {
                    ...state.terminal,
                    output: [...state.terminal.output, action.payload]
                }
            };
        case Actions.CLEAR_TERMINAL_OUTPUT:
            return {
                ...state,
                terminal: {
                    ...state.terminal,
                    output: []
                }
            };
        default:
            return state;
    }
};

export default developer;
